import Breadcrumb from "../components/Reusable/Breadcrumb";
import React from "react";
import { useTranslation } from "react-i18next";

const TermsConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="terms-main-container">
      <Breadcrumb
        title={t("terms_page_condition")}
        returnPage="/informations"
      />

      <div className="terms-content">
        <div
          dangerouslySetInnerHTML={{
            __html: t("terms_page_condition_page.content"),
          }}
        />
      </div>
    </div>
  );
};

export default TermsConditions;
